/*
  YAFATAR – Organisationsauswahl (Produktseite und Schnellkauf).
  Wird auf allen Seiten geladen, damit auch nachträglich eingefügte Auswahlfelder (Schnellkauf-Drawer) funktionieren.
  Jede Auswahl gehört über data-yf-form zu genau einem Produktformular.
*/
(function () {
  if (window.__yfImpactInit) return;
  window.__yfImpactInit = true;

  var NAME = 'properties[An wen soll deine Spende gehen?]';
  var RADIO = 'input[type="radio"][name="' + NAME + '"]';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var NET_MSG = 'Der Artikel konnte gerade nicht in den Warenkorb gelegt werden. Bitte prüfe deine Verbindung und versuche es erneut.';
  var busy = {};
  var remembered = {};

  /* Wichtig: form.id liefert bei Produktformularen das Feld name="id", deshalb getAttribute('id') */
  function formId(form) { return form && form.getAttribute ? form.getAttribute('id') : null; }
  function pickerFor(form) {
    var fid = formId(form);
    if (!fid) return null;
    var list = document.querySelectorAll('[data-yf-picker]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('data-yf-form') === fid) return list[i];
    }
    return null;
  }
  function selected(p) { return p.querySelector(RADIO + ':checked'); }

  function setPickerError(p, on) {
    p.classList.toggle('is-invalid', on);
    var er = p.querySelector('.yf-ip-error');
    if (er) er.hidden = !on;
    p.querySelectorAll(RADIO).forEach(function (i) {
      if (on) { i.setAttribute('aria-invalid', 'true'); if (er) i.setAttribute('aria-errormessage', er.id); }
      else { i.removeAttribute('aria-invalid'); i.removeAttribute('aria-errormessage'); }
    });
  }
  function scrollContainer(el) {
    var n = el.parentElement;
    while (n && n !== document.body) {
      var s = getComputedStyle(n);
      if (/(auto|scroll)/.test(s.overflowY) && n.scrollHeight > n.clientHeight) return n;
      n = n.parentElement;
    }
    return null;
  }
  function revealPicker(p) {
    var box = scrollContainer(p);
    if (box) {
      var top = p.getBoundingClientRect().top - box.getBoundingClientRect().top + box.scrollTop - 16;
      try { box.scrollTo({ top: top, behavior: 'smooth' }); } catch (e) { box.scrollTop = top; }
      return;
    }
    var h = document.querySelector('.shopify-section--header');
    var off = (h ? h.getBoundingClientRect().height : 0) + 24;
    var target = p.getBoundingClientRect().top + window.pageYOffset - off;
    try { window.scrollTo({ top: target, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, target); }
  }
  function failValidation(p) {
    setPickerError(p, true);
    revealPicker(p);
    var first = p.querySelector(RADIO);
    if (first) first.focus({ preventScroll: true });
  }
  function setAtcError(form, text) {
    var scope = form.closest('quick-buy-drawer, .quick-buy-drawer') || document;
    scope.querySelectorAll('[data-yf-atc-error]').forEach(function (el) {
      el.textContent = text || '';
      el.hidden = !text;
    });
  }

  /* 1) Kaufbutton eines Formulars mit Auswahl: ohne Organisation abbrechen */
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[type="submit"], input[type="submit"]') : null;
    if (!btn || !btn.form) return;
    var p = pickerFor(btn.form);
    if (p && !selected(p)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      failValidation(p);
    }
  }, true);

  /* 2) Absenden: eigener, geprüfter Warenkorb-Ablauf statt Theme-/App-Handler */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    var p = pickerFor(f);
    if (!p) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!selected(p)) { failValidation(p); return; }
    addToCart(f);
  }, true);

  async function addToCart(f) {
    var key = formId(f);
    if (busy[key]) return;
    busy[key] = true;
    setAtcError(f, '');
    var buttons = Array.prototype.filter.call(document.querySelectorAll('button[type="submit"]'), function (b) { return b.form === f; });
    var wasDisabled = buttons.map(function (b) { return b.disabled; });
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    try {
      var sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      var fd = new FormData(f);
      if (!fd.get('id')) throw new Error('Bitte wähle eine verfügbare Variante aus.');
      fd.set('sections', sections.join(','));
      fd.set('sections_url', ROOT + 'variants/' + fd.get('id'));
      var res;
      try {
        res = await fetch(ROOT + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } });
      } catch (netErr) {
        throw new Error(NET_MSG);
      }
      var json = {};
      try { json = await res.json(); } catch (parseErr) {}
      if (!res.ok) {
        var desc = json && (typeof json.description === 'string' ? json.description : json.message);
        throw new Error(desc || NET_MSG);
      }
      if (window.themeVariables && window.themeVariables.settings && (themeVariables.settings.cartType === 'page' || themeVariables.settings.pageType === 'cart')) {
        window.location.href = ROOT + 'cart';
        return;
      }
      var cart = await (await fetch(ROOT + 'cart.js')).json();
      cart.sections = json.sections;
      f.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.hasOwnProperty('items') ? json.items : [json], cart: cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
    } catch (err) {
      setAtcError(f, (err && err.message) || NET_MSG);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      busy[key] = false;
      buttons.forEach(function (b, i) { b.removeAttribute('aria-busy'); b.disabled = wasDisabled[i]; });
    }
  }

  /* Gültige Auswahl: Fehler entfernen und je Formular merken */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches(RADIO)) return;
    var p = t.closest('[data-yf-picker]');
    if (!p) return;
    remembered[p.getAttribute('data-yf-form')] = t.value;
    setPickerError(p, false);
  });

  /* Nach Neu-Rendern (z. B. Größenwechsel) Auswahl wiederherstellen; fremde App-Auswahl entfernen */
  function restore() {
    document.querySelectorAll('[data-yf-picker]').forEach(function (p) {
      var v = remembered[p.getAttribute('data-yf-form')];
      if (!v) return;
      p.querySelectorAll(RADIO).forEach(function (i) { if (i.value === v && !i.checked) i.checked = true; });
    });
    if (!document.querySelector('[data-yf-picker]')) return;
    document.querySelectorAll('input[name*="An wen soll deine Spende"]').forEach(function (i) {
      if (i.closest('[data-yf-picker]') || i.type === 'hidden') return;
      i.disabled = true;
      var lab = i.closest('label');
      if (lab) lab.style.display = 'none';
    });
  }
  restore();
  new MutationObserver(restore).observe(document.documentElement, { childList: true, subtree: true });
})();